import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Hidden from 'material-ui/Hidden'
import MUIMenu, {MenuItem} from 'material-ui/Menu'
import NotificationsIcon from 'material-ui-icons/Notifications'
import IconButton from 'material-ui/IconButton'
import MUITabs, {Tab as MUITab} from 'material-ui/Tabs'
import Deposit from '../../depositV2/containers/deposit'
import Rent from '../../rentV2/containers/orchestrator'
import Remove from '../../remove/containers/orchestrator'
import AddItemsToRemoval from '../../remove/containers/addItemsToRemoval'
import {header as text} from '../text'
import LoginComponent from '../../login/Login'
import SignupComponent from '../../signup/Signup'
import LiveChat from 'react-livechat'
import Tabs from './tabs'
import Logo from './logo'
import Search from './search'
import Avatar from './avatar'
import Login from './login'
import Drawer from './drawer'
import styles from '../styles'
import config from '../../../config'
import {RENT_AVAILABLE} from "../../../App"
import Dialog, {DialogTitle, DialogActions, DialogContent, DialogContentText} from 'material-ui/Dialog'
import { Button } from 'material-ui'

class Header extends React.Component {

  state = {
    anchorEl: null,
    open: false,
    openDrawer: false,
    openDialog: false
  }

  handleOpenDrawer = (open) => {
    this.setState({openDrawer: open})
  }

  handleLogoClick = () => {
    this.props.history.push('/')
  }

  handleMenuClose = () => {
    this.setState({open: false})
  }

  handleCommunityClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/')
  }

  handleMyStuffClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/micatalogo')
  }

  handleSignupClick = () => {
    this.props.history.push('/registrarse')
  }

  handleLoginClick = () => {
    // this.props.history.push('/ingresar')
    this.props.openLogin()
  }

  handleAvatarClick = e => {
    this.setState({
      // open: !this.state.open,
      // anchorEl: e.currentTarget,
      openDrawer: true,
    })
  }

  handleProfileClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/perfil')
  }

  handleSharedClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/compartido?con=migo')
  }

  handleActivityClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/actividad')
  }

  handleBalanceClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/balance')
  }

  handleFacturacionClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/facturacion')
  }

  handleHelpClick = () => {
    this.handleOpenDrawer(false)
    this.props.history.push('/ayuda')
  }

  handleAboutClick = () => {
    window.location = 'https://space.guru/nosotros.html'
  }

  handleLogoutClick = () => {
    this.setState({open: false, openDrawer: false})
    this.props.logOut()
    this.props.history.push('/')
  }

  handleDepositClick = () => {
    this.props.startDeposit()
    this.handleOpenDrawer(false)
  }

  handleOpenDialog = () => {
    this.setState({openDialog: true})
  }

  handleCloseDialog = () => {
    this.setState({openDialog: false})
  }

  isIn = (widths = []) => {
    for (let i = 0; i < widths.length; i++) {
      if (this.props.width === widths[i]) return true
    }
    return false
  }

  noneWhenIn = (widths) => this.isIn(widths) ? 'none' : undefined

  getTab = tab => {
    switch (tab) {
      case 'community':
        return 0
      case 'yours':
        return 1
      default:
        return false
    }
  }

  onChatLoaded = (ref) => {
    ref.on_before_load = () => {
      ref.hide_chat_window()
    }
    ref.on_after_load = () => {
      ref.on_chat_window_opened = () => {
        ref.set_visitor_name(`${this.props.user.name} ${this.props.user.lastName}`)
        ref.set_visitor_email(this.props.user.email)
        ref.set_custom_variables([
          {name: 'customerId', value: this.props.user.id},
        ])
      }
      ref.on_chat_window_minimized = () => {
        if (ref.chat_running() === false) {
          ref.hide_chat_window()
        }
      }
    }
  }

  renderResponsiveTabs = tab => (
      <Hidden only={['md', 'lg', 'xl']}>
        <MUITabs
            value={this.getTab(tab)}
            onChange={(e, v) => {
              switch (v) {
                case 0:
                  this.handleCommunityClick()
                  break
                case 1:
                  this.handleMyStuffClick()
                  break
                default:
              }
            }}
            centered={true}
            fullWidth={true}
            indicatorColor="secondary"
        >
          <MUITab label={text.community}/>
          <MUITab label={text.myCatalog}/>
        </MUITabs>
      </Hidden>
  )
  
  render() {
    const {classes, width, tab, isLoggedIn, show, user} = this.props
    const { pathname } = this.props.location
    if (show === false) return null

    const tabContainerStyles = RENT_AVAILABLE
        ? { display: this.noneWhenIn(['xs', 'sm']) }
        : {}

    const responsiveTabs = RENT_AVAILABLE
        ? this.renderResponsiveTabs(tab)
        : null

    return (
      <div>
        <LoginComponent fullScreen={true}/>
        <SignupComponent fullScreen={true}/>
        <Deposit/>
        <Rent/>
        <Remove/>
        <AddItemsToRemoval/>
        <LiveChat license={parseInt(config.LIVECHAT_KEY, 10)} onChatLoaded={this.onChatLoaded}/>
        <AppBar position="fixed" color="default" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <div style={{flex: this.isIn(['lg', 'xl']) ? 1 : 0}}>
              <Logo goHome={this.handleLogoClick}/>
            </div>
            {(isLoggedIn || pathname === '/') &&
            <div style={{
              flex: 0,
              justifyContent: 'center',
              display: this.noneWhenIn(['xs', 'sm', 'md']),
            }}>
              <Search searchText={this.props.searchText} setSearch={this.props.setSearch} mini={false}/>
            </div>
            }
            <div style={{display: 'flex', flex: 1, justifyContent: 'flex-end'}}>
              {(isLoggedIn || pathname === '/') &&
              <div style={{
                display: this.noneWhenIn(['lg', 'xl']),
                marginTop: 5,
                padding: width === 'xs' ? '' : '0 16px',
              }}>
                <Search
                    searchText={this.props.searchText}
                    setSearch={this.props.setSearch}
                    mini={width === 'xs'}
                />
              </div>
              }
              <div style={tabContainerStyles}>
                <Tabs tab={tab} goCommunity={this.handleCommunityClick} goMyStuff={this.handleMyStuffClick}/>
              </div>
              {isLoggedIn === false ? (
                <Login goLogin={this.handleLoginClick} goSignup={this.handleSignupClick}/>
              ) : (
                <div style={{marginTop: 5}}>
                  <IconButton style={{width: 48}} onClick={this.handleActivityClick}><NotificationsIcon/></IconButton>
                  <Avatar openMenu={this.handleAvatarClick} picture={user.picture}/>
                </div>
              )}
            </div>
            <MUIMenu
              id="header-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              onClick={this.handleMenuClose}
              anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
              getContentAnchorEl={null}
            >
              <MenuItem className={classes.menuItem} onClick={this.handleProfileClick}>{text.profile}</MenuItem>
              <MenuItem className={classes.menuItem} onClick={this.handleSharedClick}>{text.shared}</MenuItem>
              <MenuItem className={classes.menuItem} onClick={this.handleActivityClick}>{text.activity}</MenuItem>
              <MenuItem className={classes.menuItem} onClick={this.handleLogoutClick}>{text.logOut}</MenuItem>
            </MUIMenu>
          </Toolbar>
          <Drawer
            isOpen={this.state.openDrawer}
            onChange={open => this.setState({openDrawer: open})}
            items={[
              {label: text.profile, onClick: this.handleProfileClick},
              {label: text.activity, onClick: this.handleActivityClick},
              {label: text.balance, onClick: this.handleBalanceClick},
              {label: text.billing, onClick: this.handleFacturacionClick},
              {isDivider: true},
              {label: text.help, onClick: this.handleHelpClick},
              {label: text.about, onClick: this.handleAboutClick},
              {label: text.logOut, onClick: this.handleLogoutClick},
            ]}
            user={{
              name: user.name,
              picture: user.picture,
              items: user.items,
              onClick: () => {},
            }}
            action={{
              label: 'Programar retiro',
              onClick: this.handleOpenDialog,
            }}
          />
          {responsiveTabs}
        </AppBar>
        <Dialog open={this.state.openDialog} onClose={this.handleCloseDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
          <DialogTitle id="alert-dialog-title">Programar Retiro</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Debido a la alta demanda de solicitudes, te pedimos que te comuniques con uno de nuestros asesores
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDialog} color="primary" autoFocus>
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

Header.propTypes = {
  show: PropTypes.bool.isRequired,
  showSearchBar: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  tab: PropTypes.oneOf(['community', 'yours', '', 'catalog']),
  searchText: PropTypes.string,
  setSearch: PropTypes.func,
  logOut: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    picture: PropTypes.string,
    items: PropTypes.number,
  }),
  openLogin: PropTypes.func.isRequired,
  startDeposit: PropTypes.func.isRequired,
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Header)



// WEBPACK FOOTER //
// ./src/sections/header/components/Header.js